export default __webpack_public_path__ + "static/media/23-Michael.e5173aba.jpg";